import {CreatedExternalAuthorization, CreateExternalAuthorization} from "../Types";
import jsonApi from "./jsonApi";

export async function create(req: CreateExternalAuthorization) {
  return await jsonApi.post<CreatedExternalAuthorization>("/external_authorizations", req);
}
